













import { Component, Vue, Prop } from 'vue-property-decorator'
import { GameLog, NightAction, ReplayLog } from '@/class/game'
import ReplayViewer from './ReplayViewer.vue'

@Component({
  components: {
    ReplayViewer
  }
})
export default class Replay extends Vue {
  @Prop() gameLogs!: GameLog[]
  logCounter = this.replayLogs.length - 1
  turnLog = 0

  get gameLog () {
    return this.replayLogs[this.logCounter]
  }

  get replayLogs () {
    const logs: ReplayLog[] = []

    this.gameLogs.forEach(log => {
      if (log.nightAction) {
        logs.push(...this.makeNightLogs(log, log.nightAction))
      } else {
        logs.push(log)
      }
    })

    return logs
  }

  makeNightLogs(log: GameLog, nightAction: NightAction): ReplayLog[] {
    return nightAction.playLogs.map(l => {
      return { day: log.day, state: log.state, action: l, timestamp: log.timestamp }
    })
  }

  start() {
    this.turnLog = setInterval(() => this.next(), 5000)
  }

  reset() {
    this.logCounter = 0
  }

  next() {
    if (this.logCounter >= this.replayLogs.length - 1) {
      clearInterval(this.turnLog)
    } else {
      this.logCounter++
    }
  }

  prev() {
    if (this.logCounter > 0) {
      this.logCounter--
    }
  }
}
